import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { bool, number, string } from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { SA_SELLER_ID } from 'shared/consts/checkout'
import { isPupSelected as isPupSelectedSelector } from 'shared/store-checkout/duck/address'
import {
  fetchShippingOptionsAction,
  hasMarketPlaceOrders as hasMarketPlaceOrdersSelector,
} from 'shared/store-checkout/duck/shipse'
import Price from 'views/components/atoms/Price'
import ShippingAddressOptionsList from 'views/components/organisms/Checkout/ShippingAddressOptionsList'
import ShippingOptionsList from 'views/components/organisms/Checkout/ShippingOptionsList'
import SubOrderProductImages from 'views/components/organisms/Checkout/SubOrderProductImages'
import './ShipmentBySubOrder.scss'

const ShipmentBySubOrder = ({
  sellerNumber,
  sellerCount,
  sellerId,
  subOrderId,
  totalAmountRedpoints,
  isAddressSelection,
  isShippingCostModal,
  isPrescriptionOrder,
  isRedPointsModal,
  totalAmount,
  deliveryMode,
  freeShippingBargain,
  shippingCosts,
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchShippingOptionsAction())
    // TODO for code owners: consider fixing and/or removing this line
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isPupSelected = useSelector(state =>
    isPupSelectedSelector(state, subOrderId)
  )
  const hasMarketPlaceOrders = useSelector(state =>
    hasMarketPlaceOrdersSelector(state)
  )

  const pupNotAllowed =
    hasMarketPlaceOrders && isPupSelected && sellerId !== SA_SELLER_ID

  const showShippingCost =
    shippingCosts !== 0 ? (
      <Price amount={shippingCosts} symbolLeft />
    ) : (
      <span className="u-color--positive">
        <Trans id="checkout.ShippingServiceList.shippingCompany.freeDelivery" />
      </span>
    )

  const showFreeShippingBargain =
    freeShippingBargain > 0 ? (
      <div className="o-ShipmentBySubOrder__header--seller u-color--grey a-h1 ">
        <Trans id="general.label.shippingBargain" />
        <Price amount={freeShippingBargain} symbolLeft />
      </div>
    ) : null

  const showFreeShipping =
    freeShippingBargain === 0 ? (
      <div className="o-ShipmentBySubOrder__header--seller u-color--grey a-h1 ">
        <Trans id="uspBox.headline.noShippingCosts" />
      </div>
    ) : null

  const showShipmentBySeller = isRedPointsModal ? (
    <div
      className={classNames({
        'u-color--greyLight': !totalAmountRedpoints,
      })}
    >
      <Trans
        id="checkout.ShipmentBySeller.title"
        values={{ sellerNumber, sellerCount }}
      />
    </div>
  ) : (
    <div>
      <Trans
        id="checkout.ShipmentBySeller.title"
        values={{ sellerNumber, sellerCount }}
      />
    </div>
  )

  const redPointsModalNoSAESeller =
    isRedPointsModal && totalAmountRedpoints ? (
      <div className="o-ShipmentBySubOrder__relatedProductList l-grid__item l-col--12-of-12@small-tiny u-margin--bottom">
        <SubOrderProductImages subOrderId={subOrderId} forceLeft flexAndwrap />
      </div>
    ) : (
      <div className="l-grid__item@large l-col--6-of-12@large u-vertical-align--bottom@large u-padding--bottom@large u-color--negative u-font-weight--bold">
        <Trans id="checkout.verification.redPointsModal.excludedFromRedPointsProgram" />
      </div>
    )

  const redPointsModalClassMarginBottom =
    isRedPointsModal && !totalAmountRedpoints
      ? 'o-ShipmentBySubOrder__header--seller u-color--grey'
      : 'o-ShipmentBySubOrder__header--seller u-color--grey a-h1 u-margin-large--bottom'

  return (
    <>
      <div className="o-ShipmentBySubOrder ">
        {pupNotAllowed && (
          <div className="o-ShipmentBySubOrder__warning u-margin-large--bottom">
            <Trans id="checkout.ShipmentBySeller.chooseOtherShippingMethod" />
          </div>
        )}

        <div className="o-ShipmentBySubOrder__header a-label l-col--12-of-12@small-tiny">
          {hasMarketPlaceOrders && (
            <div className="a-label">{showShipmentBySeller}</div>
          )}
          <div className={redPointsModalClassMarginBottom}>
            {hasMarketPlaceOrders && (
              <Trans
                id="checkout.ShipmentBySeller.seller"
                values={{ seller: sellerId }}
              />
            )}
            {!hasMarketPlaceOrders && (
              <div className="u-color--dark a-h3 u-no-margin">
                <Trans
                  id="checkout.ShipmentBySeller.seller"
                  values={{ seller: sellerId }}
                />
              </div>
            )}
            {isRedPointsModal && sellerId === SA_SELLER_ID && (
              <div className="u-color--grey u-no-margin">
                <Trans id="redPointsModal.redeemedRedPoints.forProducts.subText.headline" />
              </div>
            )}

            {isShippingCostModal &&
              !isPrescriptionOrder &&
              (freeShippingBargain > 0
                ? showFreeShippingBargain
                : showFreeShipping)}

            {isShippingCostModal && isPrescriptionOrder && (
              <div className="o-ShipmentBySubOrder__header--seller u-color--grey a-h1 ">
                <Trans id="uspBox.headline.noShippingCosts" />
              </div>
            )}
          </div>
        </div>

        {!isRedPointsModal && (
          <div className="o-ShipmentBySubOrder__relatedProductList l-grid__item l-col--12-of-12@small-tiny u-margin--bottom">
            <SubOrderProductImages
              subOrderId={subOrderId}
              forceLeft
              flexAndwrap
            />
          </div>
        )}

        {isRedPointsModal && <>{redPointsModalNoSAESeller}</>}

        {!isShippingCostModal && !isRedPointsModal && (
          <div className="o-ShipmentBySubOrder__list">
            {isAddressSelection && (
              <ShippingAddressOptionsList
                sellerId={sellerId}
                subOrderId={subOrderId}
                isPupSelected={isPupSelected}
                hasMarketPlaceOrders={hasMarketPlaceOrders}
              />
            )}
            {!isAddressSelection && (
              <ShippingOptionsList
                sellerId={sellerId}
                subOrderId={subOrderId}
              />
            )}
          </div>
        )}
      </div>

      {isShippingCostModal && (
        <>
          <hr className="o-VerificationPage u-no-margin u-visible@large u-hidden u-margin--bottom" />
          <div className="l-flex l-flex--distribute-space a-h5 u-margin-x-small--ends">
            <div>
              <Trans id="general.label.subTotal" />
            </div>
            <div>
              <Price amount={totalAmount} symbolLeft />
            </div>
          </div>

          <div className="l-flex l-flex--distribute-space a-h4 u-no-margin--bottom">
            <div>
              <Trans id="account.orders.details.delivery.standardWith" />{' '}
              {deliveryMode}
            </div>
            <div>{showShippingCost}</div>
          </div>
        </>
      )}
      {isRedPointsModal && totalAmountRedpoints > 0 && (
        <>
          <hr className="o-VerificationPage u-no-margin u-visible@large u-hidden u-margin--bottom" />
          <div className="l-flex l-flex--distribute-space a-h5 u-margin-x-small--ends">
            <div>
              <Trans id="general.label.subTotal" />
            </div>
            <div>
              <Price amount={totalAmount} symbolLeft />
            </div>
          </div>

          <div className="l-flex l-flex--distribute-space a-h4 u-no-margin--bottom">
            <div>
              <Trans id="general.label.redPoints" />
            </div>
            <div className="u-color--positive">
              -{' '}
              <Price
                amount={totalAmountRedpoints}
                symbolLeft
                decimalPlaces={2}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}

ShipmentBySubOrder.propTypes = {
  sellerNumber: number,
  sellerCount: number,
  sellerId: string.isRequired,
  subOrderId: string.isRequired,
  isAddressSelection: bool,
  totalAmountRedpoints: number,
  isShippingCostModal: bool,
  isPrescriptionOrder: bool,
  isRedPointsModal: bool,
  totalAmount: number,
  deliveryMode: string,
  freeShippingBargain: number,
  shippingCosts: number,
}
ShipmentBySubOrder.defaultProps = {
  sellerNumber: 1,
  sellerCount: 1,
  isAddressSelection: true,
  totalAmountRedpoints: 0,
  isShippingCostModal: false,
  isPrescriptionOrder: false,
  isRedPointsModal: false,
  totalAmount: null,
  deliveryMode: null,
  freeShippingBargain: null,
  shippingCosts: null,
}

export default ShipmentBySubOrder
